/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	tipWrapper: {
		paddingInline: token('space.050'),
		paddingBlockEnd: token('space.150'),
		color: token('color.text.subtlest'),
		font: token('font.body.small'),
	},
});

const messages = defineMessages({
	micPermissionTip: {
		id: 'ai-mate.chat-prompt-input.mic-permission-tip.message',
		defaultMessage:
			'<bold>Tip:</bold> You must allow microphone access in your browser settings to use dictation.',
		description:
			'Tip shown when the user has denied microphone permission, suggesting they enable it in browser settings. The Tip: prefix is bold.',
	},
});

/**
 * Informational tip shown when the user has denied microphone access.
 * Renders in the same location and visual style as `ConnectorSourceConnectionTip`.
 */
export const DictationMicPermissionTip = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.tipWrapper}>
			{formatMessage(messages.micPermissionTip, {
				bold: (chunks: React.ReactNode[]) => (
					<Text size="small" weight="medium" color="color.text">
						{chunks}
					</Text>
				),
			})}
		</Box>
	);
};
